// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"gZ-z"};